<script>
import SkyList from 'sky-list';
import SkySearchMixin from 'sky-search/sky-search.mixin';

const preferences = {
	api: '/umbraco/api/SiteSearchApi/Search/',
	pagination: true,
	fetchConditions: {
		keywords(keywords) {
			return keywords.length;
		},
	},
};

const parameters = {
	keywords: '',
	limit: 10,
};

export default {
	mixins: [SkySearchMixin],
	data() {
		return {
			list: new SkyList(preferences, parameters),
			parameters,
		};
	},
	created() {
		/**
		 * Populate keywords from list in case it has intial value
		 * (from url string for instance)
		 */
		Object.keys(this.parameters).forEach((key) => {
			if (key in this.list.params) {
				this.parameters[key] = this.list.params[key];
			}
		});

		if (this.parameters.keywords.length) {
			this.$store.dispatch('skyOverlay/toggle', {
				name: 'search',
				active: true,
			});
		}
	},
	watch: {
		parameters: {
			handler() {
				// Keep list params in sync
				Object.keys(this.parameters).forEach((key) => {
					if (this.list.params[key] !== this.parameters[key]) {
						this.list.params[key] = this.parameters[key];
						// Reset offset if params have changed
						this.list.params.offset = 0;
					}
				});
				this.update();
			},
			deep: true,
		},
		'$store.state.skyOverlay.overlays.search.active': {
			handler() {
				this.$refs.searchInput.focus();
			},
		},
	},
	methods: {
		update() {
			// Only update if keywords length is above 1
			if (this.parameters.keywords.length > 1) {
				this.list.update();
			} else {
				this.list.reset();
			}
		},
		toPage(offset) {
			this.list._fetch(offset);
		},
		numNavActiveClass(page) {
			return page * this.list.params.limit - this.list.params.limit === this.list.params.offset;
		},
	},
};
</script>

<style src="./sky-search.scss"></style>
<template src="./sky-search.html"></template>



// WEBPACK FOOTER //
// sky-search.vue?2ce65922